// extracted by mini-css-extract-plugin
export var anchoredAnimation = "ScrollAnimation-module--anchored-animation--ab5aa";
export var columns = "ScrollAnimation-module--columns--16644";
export var cta = "ScrollAnimation-module--cta--bec9e";
export var feature = "ScrollAnimation-module--feature--711f1";
export var features = "ScrollAnimation-module--features--5e553";
export var image = "ScrollAnimation-module--image--751fc";
export var scrollAnimation = "ScrollAnimation-module--scroll-animation--f03da";